module.exports = __webpack_public_path__ + "img/Flag_of_Cameroon.10dfd965.svg";